import React, { useEffect, useState } from 'react';
import { getIntegracionesPanel, getIntegracionesLogs, getWebhooks, crearWebhook, editarWebhook, eliminarWebhook, probarWebhook, getApiKeys, crearApiKey, revocarApiKey, API_BASE } from '../services/api';

const fdt = (d) => d ? new Date(d).toLocaleString('es-CO', { dateStyle: 'short', timeStyle: 'short' }) : '—';
const EST = { ok: { c: '#10b981', l: 'OK' }, error: { c: '#ef4444', l: 'Error' }, info: { c: '#94a3b8', l: 'Info' } };
const ORIGEN = { dian: { l: 'DIAN', c: '#3b82f6' }, siigo: { l: 'Siigo', c: '#8b5cf6' }, email: { l: 'Correo', c: '#f59e0b' }, webhook: { l: 'Webhook', c: '#10b981' } };

export default function Integraciones() {
  const [tab, setTab] = useState('panel');
  const [panel, setPanel] = useState([]);
  const [logs, setLogs] = useState([]);
  const [fOrigen, setFOrigen] = useState('');
  const [fEstado, setFEstado] = useState('');

  useEffect(() => { getIntegracionesPanel().then(r => setPanel(r.data)).catch(() => {}); }, []);
  const loadLogs = () => getIntegracionesLogs({ origen: fOrigen || undefined, estado: fEstado || undefined }).then(r => setLogs(r.data)).catch(() => {});
  useEffect(() => { if (tab === 'logs') loadLogs(); /* eslint-disable-next-line */ }, [tab, fOrigen, fEstado]);

  return (
    <div>
      <div style={s.header}><div><h1 style={s.h1}>Integraciones</h1><p style={s.sub}>Estado de las conexiones y registro de actividad</p></div></div>
      <div style={s.tabs}>
        {[['panel', 'Panel'], ['webhooks', 'Webhooks'], ['api', 'API para terceros'], ['logs', 'Log de integraciones']].map(([k, l]) => <button key={k} style={{ ...s.tab, ...(tab === k ? s.tabOn : {}) }} onClick={() => setTab(k)}>{l}</button>)}
      </div>

      {tab === 'panel' && (
        <div style={s.grid}>
          {panel.map(x => (
            <div key={x.clave} style={s.conn}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, color: '#f1f5f9', fontSize: 14 }}>{x.nombre}</span>
                <span style={{ ...s.dot, background: x.conectado ? '#10b981' : '#64748b' }} />
              </div>
              <div style={{ color: x.conectado ? '#34d399' : '#94a3b8', fontSize: 12, marginTop: 6 }}>{x.conectado ? '● Conectado' : '○ Sin configurar'}</div>
              <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 8 }}>{x.detalle}</div>
              <div style={{ borderTop: '1px solid #334155', marginTop: 12, paddingTop: 10, fontSize: 12, color: '#64748b' }}>
                {x.ultima ? <>Última actividad: {fdt(x.ultima)}<br />
                  <span style={{ color: '#34d399' }}>{x.ok || 0} ok</span> · <span style={{ color: '#fca5a5' }}>{x.errores || 0} errores</span> <span style={{ color: '#475569' }}>(30 días)</span></>
                  : 'Sin actividad registrada aún'}
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'webhooks' && <Webhooks />}
      {tab === 'api' && <ApiKeys />}

      {tab === 'logs' && (
        <>
          <div style={s.barra}>
            <select style={s.input} value={fOrigen} onChange={e => setFOrigen(e.target.value)}><option value="">Todos los orígenes</option><option value="dian">DIAN</option><option value="siigo">Siigo</option><option value="email">Correo</option><option value="webhook">Webhook</option></select>
            <select style={s.input} value={fEstado} onChange={e => setFEstado(e.target.value)}><option value="">Todos los estados</option><option value="ok">OK</option><option value="error">Error</option><option value="info">Info</option></select>
          </div>
          <div style={s.card}><table style={s.table}>
            <thead><tr>{['Fecha', 'Origen', 'Evento', 'Estado', 'Mensaje', 'Ref.'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {logs.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin registros. Aquí aparecerán las emisiones DIAN, sincronizaciones Siigo, correos, etc.</td></tr>}
              {logs.map(l => (
                <tr key={l.id}>
                  <td style={s.td}>{fdt(l.created_at)}</td>
                  <td style={s.td}><span style={{ ...s.chip, background: (ORIGEN[l.origen]?.c || '#64748b') + '22', color: ORIGEN[l.origen]?.c || '#94a3b8' }}>{ORIGEN[l.origen]?.l || l.origen}</span></td>
                  <td style={{ ...s.td, color: '#e2e8f0' }}>{l.evento || '—'}</td>
                  <td style={s.td}><span style={{ color: (EST[l.estado] || EST.info).c, fontWeight: 600 }}>{(EST[l.estado] || EST.info).l}</span></td>
                  <td style={{ ...s.td, color: l.estado === 'error' ? '#fca5a5' : '#94a3b8', maxWidth: 400 }}>{l.mensaje || '—'}</td>
                  <td style={s.td}>{l.referencia || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </>
      )}
    </div>
  );
}

function ApiKeys() {
  const [keys, setKeys] = useState([]);
  const [nueva, setNueva] = useState(null); // { key, prefijo } recién creada
  const [nombre, setNombre] = useState('');
  const base = (API_BASE || 'https://erpapi.snelapp.com') + '/api/v1';
  const load = () => getApiKeys().then(r => setKeys(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const crear = async () => {
    const n = window.prompt('Nombre de la llave (ej: "Integración web"):');
    if (!n) return;
    try { const { data } = await crearApiKey({ nombre: n }); setNueva(data); load(); } catch { alert('Error'); }
  };
  const revocar = async (k) => { if (window.confirm(`¿Revocar la llave "${k.nombre}"? Dejará de funcionar de inmediato.`)) { await revocarApiKey(k.id); load(); } };
  const copiar = (t) => { navigator.clipboard?.writeText(t); };
  return (
    <div>
      {nueva && (
        <div style={{ background: '#052e1a', border: '1px solid #16a34a', borderRadius: 10, padding: 14, marginBottom: 16 }}>
          <div style={{ color: '#86efac', fontWeight: 600, marginBottom: 6 }}>✅ Llave creada — cópiala ahora, no se volverá a mostrar:</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <code style={{ flex: 1, background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '8px 10px', color: '#93c5fd', fontSize: 13, wordBreak: 'break-all' }}>{nueva.key}</code>
            <button style={s.wbbtn} onClick={() => copiar(nueva.key)}>Copiar</button>
            <button style={s.wbsec} onClick={() => setNueva(null)}>Ocultar</button>
          </div>
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ color: '#64748b', fontSize: 13 }}>Llaves para que sistemas externos consuman tu API con <code>X-API-Key</code>.</span>
        <button style={s.wbbtn} onClick={crear}>+ Generar llave</button>
      </div>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Nombre', 'Llave', 'Último uso', 'Estado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {keys.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin llaves. Genera una para dar acceso a la API.</td></tr>}
          {keys.map(k => (
            <tr key={k.id}>
              <td style={{ ...s.td, color: '#e2e8f0', fontWeight: 600 }}>{k.nombre}</td>
              <td style={{ ...s.td, fontFamily: 'ui-monospace', fontSize: 12 }}>{k.prefijo}</td>
              <td style={s.td}>{k.ultimo_uso ? fdt(k.ultimo_uso) : 'Nunca'}</td>
              <td style={s.td}><span style={{ color: k.activo ? '#34d399' : '#94a3b8' }}>{k.activo ? 'Activa' : 'Revocada'}</span></td>
              <td style={s.td}>{k.activo && <button style={{ ...s.lnk, color: '#fca5a5' }} onClick={() => revocar(k)}>Revocar</button>}</td>
            </tr>
          ))}
        </tbody>
      </table></div>
      <div style={{ ...s.card, marginTop: 16, padding: 16 }}>
        <div style={{ color: '#f1f5f9', fontWeight: 700, marginBottom: 10 }}>📘 Documentación rápida</div>
        <div style={{ color: '#94a3b8', fontSize: 13, lineHeight: 1.7 }}>
          <div>Base URL: <code style={s.code}>{base}</code></div>
          <div>Autenticación: cabecera <code style={s.code}>X-API-Key: snel_…</code></div>
          <div style={{ marginTop: 8, color: '#cbd5e1' }}>Endpoints:</div>
          <ul style={{ margin: '4px 0', paddingLeft: 18 }}>
            <li><code style={s.code}>GET /clientes?q=</code> — listar/buscar clientes</li>
            <li><code style={s.code}>POST /clientes</code> — crear cliente <span style={{ color: '#64748b' }}>{'{ razon_social, nit, ... }'}</span></li>
            <li><code style={s.code}>GET /productos?q=</code> — listar productos</li>
            <li><code style={s.code}>GET /facturas?estado=&desde=</code> — listar facturas</li>
          </ul>
          <div style={{ marginTop: 8, color: '#cbd5e1' }}>Ejemplo:</div>
          <pre style={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: 12, fontSize: 12, color: '#93c5fd', overflowX: 'auto', margin: '4px 0 0' }}>{`curl -H "X-API-Key: snel_..." \\
  "${base}/clientes?q=acme"`}</pre>
        </div>
      </div>
    </div>
  );
}

function Webhooks() {
  const [hooks, setHooks] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [modal, setModal] = useState(false);
  const [f, setF] = useState({});
  const [msg, setMsg] = useState(null);
  const load = () => getWebhooks().then(r => { setHooks(r.data.webhooks); setEventos(r.data.eventos); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const flash = (ok, t) => { setMsg({ ok, t }); setTimeout(() => setMsg(null), 4000); };
  const abrir = (w) => { setF(w ? { ...w, eventos: w.eventos || [] } : { nombre: '', url: '', eventos: [], activo: true }); setModal(true); };
  const toggleEv = (ev) => setF(x => ({ ...x, eventos: x.eventos.includes(ev) ? x.eventos.filter(e => e !== ev) : [...x.eventos, ev] }));
  const guardar = async () => {
    if (!f.nombre || !f.url) return flash(false, 'Nombre y URL requeridos');
    try { f.id ? await editarWebhook(f.id, f) : await crearWebhook(f); setModal(false); load(); flash(true, 'Webhook guardado'); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  const borrar = async (w) => { if (window.confirm(`¿Eliminar "${w.nombre}"?`)) { await eliminarWebhook(w.id); load(); } };
  const probar = async (w) => { try { const { data } = await probarWebhook(w.id); flash(data.ok, data.ok ? `Prueba OK (HTTP ${data.status})` : `Falló: ${data.error || 'HTTP ' + data.status}`); } catch { flash(false, 'Error'); } };
  return (
    <div>
      {msg && <div style={{ ...s.wbmsg, ...(msg.ok ? s.wbok : s.wberr) }}>{msg.ok ? '✅ ' : '❌ '}{msg.t}</div>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ color: '#64748b', fontSize: 13 }}>El ERP hará POST a estas URLs cuando ocurran los eventos, firmado con HMAC-SHA256 (cabecera <code>X-Snel-Signature</code>).</span>
        <button style={s.wbbtn} onClick={() => abrir(null)}>+ Nuevo webhook</button>
      </div>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Nombre', 'URL', 'Eventos', 'Estado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {hooks.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin webhooks. Crea uno para notificar a sistemas externos.</td></tr>}
          {hooks.map(w => (
            <tr key={w.id}>
              <td style={{ ...s.td, color: '#e2e8f0', fontWeight: 600 }}>{w.nombre}</td>
              <td style={{ ...s.td, fontFamily: 'ui-monospace', fontSize: 12, maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis' }}>{w.url}</td>
              <td style={s.td}>{(w.eventos || []).map(e => <span key={e} style={{ ...s.chip, background: '#33415588', color: '#cbd5e1', marginRight: 4 }}>{e}</span>)}</td>
              <td style={s.td}><span style={{ color: w.activo ? '#34d399' : '#94a3b8' }}>{w.activo ? 'Activo' : 'Inactivo'}</span></td>
              <td style={s.td}><button style={s.lnk} onClick={() => probar(w)}>Probar</button><button style={s.lnk} onClick={() => abrir(w)}>Editar</button><button style={{ ...s.lnk, color: '#fca5a5' }} onClick={() => borrar(w)}>Eliminar</button></td>
            </tr>
          ))}
        </tbody>
      </table></div>
      {modal && (
        <div style={s.ov}><div style={s.md}>
          <div style={s.mh}><h2 style={{ margin: 0, color: '#f1f5f9', fontSize: 18 }}>{f.id ? 'Editar webhook' : 'Nuevo webhook'}</h2><button style={s.cl} onClick={() => setModal(false)}>✕</button></div>
          <div style={{ padding: '16px 20px' }}>
            <div style={s.fld}><label style={s.lb}>Nombre</label><input style={s.input} value={f.nombre} onChange={e => setF({ ...f, nombre: e.target.value })} /></div>
            <div style={s.fld}><label style={s.lb}>URL (endpoint que recibe el POST)</label><input style={s.input} value={f.url} placeholder="https://tu-sistema.com/webhook" onChange={e => setF({ ...f, url: e.target.value })} /></div>
            {f.secret && <div style={{ color: '#64748b', fontSize: 11, marginBottom: 10 }}>Secret para verificar la firma: <code style={{ color: '#93c5fd' }}>{f.secret}</code></div>}
            <div style={s.fld}><label style={s.lb}>Eventos que disparan el webhook</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                {eventos.map(ev => (
                  <label key={ev} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#cbd5e1', background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '5px 9px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={(f.eventos || []).includes(ev)} onChange={() => toggleEv(ev)} />{ev}</label>
                ))}
              </div>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, marginTop: 8 }}><input type="checkbox" checked={f.activo !== false} onChange={e => setF({ ...f, activo: e.target.checked })} /> Activo</label>
          </div>
          <div style={s.mf}><button style={s.wbsec} onClick={() => setModal(false)}>Cancelar</button><button style={s.wbbtn} onClick={guardar}>Guardar</button></div>
        </div></div>
      )}
    </div>
  );
}

const s = {
  header: { marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  tabs: { display: 'flex', gap: 8, marginBottom: 18, borderBottom: '1px solid #334155' },
  tab: { background: 'none', border: 'none', color: '#94a3b8', padding: '10px 16px', fontSize: 14, cursor: 'pointer', borderBottom: '2px solid transparent' },
  tabOn: { color: '#f1f5f9', borderBottom: '2px solid #4f46e5', fontWeight: 600 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 },
  conn: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18 },
  dot: { width: 10, height: 10, borderRadius: '50%', display: 'inline-block' },
  barra: { display: 'flex', gap: 10, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0f172a', color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px', padding: '10px 14px', textAlign: 'left' },
  td: { padding: '9px 14px', color: '#cbd5e1', borderBottom: '1px solid #1a2332', verticalAlign: 'top' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  chip: { fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, boxSizing: 'border-box', width: '100%' },
  wbbtn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  wbsec: { background: '#334155', color: '#cbd5e1', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, cursor: 'pointer' },
  lnk: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 12 },
  wbmsg: { padding: '10px 14px', borderRadius: 8, marginBottom: 14, fontSize: 13 },
  wbok: { background: '#052e1a', border: '1px solid #16a34a', color: '#86efac' },
  wberr: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5' },
  ov: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  md: { background: '#1e293b', borderRadius: 16, width: '94%', maxWidth: 560, maxHeight: '92vh', overflowY: 'auto', border: '1px solid #334155' },
  mh: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #334155' },
  mf: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 20px', borderTop: '1px solid #334155' },
  cl: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  fld: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  lb: { color: '#94a3b8', fontSize: 12 },
  code: { background: '#0f172a', border: '1px solid #334155', borderRadius: 4, padding: '1px 6px', color: '#93c5fd', fontSize: 12 },
};
